import { RouteUtils } from "./RouteUtils";

export class ApiRoutes {
    static APP_API_URL_BACKEND = (context: string | null = null) => {
        const serverName = window.location.hostname;
        let urlSpring;

        if (context === null) {
            context = RouteUtils.getContext();
        }

        if (serverName !== "localhost") {
            return `${window.location.origin}/api-bo-${context}`;
        }

        urlSpring = "http://localhost:";

        switch (context) {
            case "be":
                urlSpring += "8086";
                break;
            case "nl":
                urlSpring += "8087";
                break;
            case "ci":
                urlSpring += "8088";
                break;
            case "vbk":
                urlSpring += "8089";
                break;
            case "govex":
                urlSpring += "8090";
                break;
            default:
                urlSpring += "8081";
                break;
        }

        urlSpring += "/api-bo-" + context;

        return urlSpring;
    };

    static REACT_APP_BASE_URL_DEV_FRONTEND = () => {
        if (window.location.hostname.includes("localhost")) {
            return "http://localhost:3000";
        }
        return (window.location.origin);
    };

    static REACT_APP_CONTEXT_URL_FRONTEND = () => {
        return window.location.origin;
    };

    //region app url
    static APP_URL_LOGIN = RouteUtils.getBackofficeServletBasename() + "/bo_logout";
    static REACT_APP_LOGIN_LANGUAGE = this.APP_API_URL_BACKEND() + "/v1/language";
    static REACT_APP_LOGIN_LANGUAGE_FRENCH_AND_DUTCH = this.APP_API_URL_BACKEND() + "/v1/language/french-dutch";
    //endregion

    //region Spring rest Urls

    //tools
    static REST_API_URL_TOOLS_EMAIL_VALIDATION: string = this.APP_API_URL_BACKEND() + "/v1/tools/email-validation";

    //region auth
    static REACT_APP_URL_AUTHENTICATE = this.APP_API_URL_BACKEND() + "/v1/auth/authenticate";
    static REACT_APP_URL_REFRESH_TOKEN = this.APP_API_URL_BACKEND() + "/v1/auth/refresh-token";
    static REACT_APP_URL_LOGOUT = this.APP_API_URL_BACKEND() + "/v1/auth/logout";
    static REACT_APP_URL_CHANGE_PASSWORD = this.APP_API_URL_BACKEND() + "/v1/auth/change-password";
    static REACT_APP_URL_BO_LOGIN = this.APP_API_URL_BACKEND() + "/v1/auth/bo-login";
    static REACT_APP_URL_GOOGLE_LOGIN = this.APP_API_URL_BACKEND() + "/v1/auth/google-login";
    static REACT_APP_URL_FORGOT_PASSWORD = this.APP_API_URL_BACKEND() + "/v1/auth/forgot-password";
    ///api-be/v1/auth/verify/reset-password-token
    static REACT_APP_URL_RESET_PASSWORD_TOKEN = this.APP_API_URL_BACKEND() + "/v1/auth/verify/reset-password-token";

    //counters
    static COUNTER_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/counters";
    static COUNTER_SIDEBAR_ENDPOINT: string = this.COUNTER_ENDPOINT + "/sidebar-counters";
    static COUNTER_SITEMAP_ENDPOINT: string = this.COUNTER_ENDPOINT + "/sitemap-counters";

    //REST API
    static REACT_APP_URL_MEMBER: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/member";
    static REACT_APP_URL_MEMBER_UPDATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/member/contact/update";
    static REACT_APP_URL_MEMBER_GRAYDON_SCORE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/member/graydon-score/update";
    static REACT_APP_URL_MEMBER_UPDATE_LOGO: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/member/upload-logo";
    static REACT_APP_URL_MEMBER_UPDATE_ACCOUNT_MANAGER: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/member/change-account-manager";
    static REACT_APP_URL_MEMBER_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/member/contact/";
    static REACT_APP_URL_MEMBER_STOP: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/member-stop";
    static REACT_APP_URL_PARTNERPREMIUMPRICING: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-premium-pricing";
    static REACT_APP_URL_PARTNERPREMIUMPRICING_CATEGORIES: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-premium-pricing/categories";
    static REACT_APP_URL_PARTNERPREMIUMPRICING_EXPERTBUSTYPES: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-premium-pricing/expertbustypes";
    static REACT_APP_URL_PARTNERPREMIUMPRICING_CREATE_UPDATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-premium-pricing/create-update";
    static REACT_APP_URL_PARTNERPREMIUMPRICING_DELETE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-premium-pricing/delete";
    static REACT_APP_URL_MEMBER_SEARCH: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/member/search";
    static REACT_APP_URL_MEMBER_AUTOCOMPLETE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/member/search/autocomplete/";
    static REACT_APP_URL_MEMBER_SWITCH_USER_GROUP: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/member/switch-user-group";
    static REACT_APP_URL_MEMBER_SEARCH_SUPPLIER: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/member/search-supplier";
    static REACT_APP_URL_MEMBER_CREATE: string = this.REACT_APP_URL_MEMBER + "/create";
    static REACT_APP_URL_MEMBER_EMAIL_EXISTS: string = this.REACT_APP_URL_MEMBER + "/email-exists";
    static REACT_APP_URL_MEMBER_LOGIN_EXISTS: string = this.REACT_APP_URL_MEMBER + "/login-exists";
    static REACT_APP_URL_MEMBER_SALES_SUPPLIERS_LIST: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/member/my-suppliers";
    static REACT_APP_URL_MEMBER_USER_SIMILARITIES: string = this.REACT_APP_URL_MEMBER + "/user-similarities";

    static REACT_APP_URL_PARTNERRFP: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp";
    static REACT_APP_URL_PARTNERRFP_SEARCH: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/search";
    static REACT_APP_URL_PARTNERRFP_SEARCH_DETAILED: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/search-detailed";
    static REACT_APP_URL_PARTNERRFP_BY_ID: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/";

    static REACT_APP_URL_SURVEY: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/survey";
    static REACT_APP_URL_SURVEY_FLAGGED: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/survey/flagged";
    static REACT_APP_URL_SURVEY_FLAGGED_COUNTS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/survey/flagged/counts";
    static REACT_APP_URL_SURVEY_FLAGGED_STATUS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/survey/flagged";
    static REACT_APP_URL_PARTNERRFP_VALIDATION_LIST: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/validation-list";
    static REACT_APP_URL_PARTNERRFP_EXTERNAL_LEADS_IN_PROCESS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/external-leads-in-process";
    static REACT_APP_URL_PARTNERRFP_COUNT : string = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/count-per-business-status/";
    static REACT_APP_URL_ASSIGNATION_ASSIGN_NEW_LEADS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/assignation/assign-new-leads";
    static REACT_APP_URL_PARTNERRFP_MY_QUEUE_LANGUAGES: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/my-queue-languages";
    static REACT_APP_URL_PARTNERRFP_REJECT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/reject";
    static REACT_APP_URL_PARTNERRFP_REJECT_NO_MAIL: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/reject-no-mail";
    static REACT_APP_URL_PARTNERRFP_COUNT_PER_STATUS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/count-per-status/";
    static REACT_APP_URL_PARTNERRFP_LAST_12_MONTHS_STATS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/leads-last-12-months";
    static REACT_APP_URL_PARTNERRFP_LAST_14_DAYS_STATS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/leads-last-14-days";
    static REACT_APP_URL_PARTNERRFP_MISSING_LEADS_LAST_14_DAYS_STATS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/missing-leads-last-14-days";
    static REACT_APP_URL_PARTNERRFP_MISSING_LEADS_LAST_12_MONTHS_STATS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/missing-leads-last-12-months";
    static REACT_APP_URL_PARTNERRFP_MONTHLY_AFFILIATE_STATS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/leads/monthly-by-affiliate";
    static REACT_APP_URL_PARTNERRFP_SEMIANNUAL_AFFILIATE_STATS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/leads/semiannual-by-affiliate";
    static REACT_APP_URL_PARTNERRFP_AFFILIATE_LEADS_PER_YEAR_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/total-leads-per-year-month";
    static REACT_APP_URL_PARTNERRFP_AFFILIATE_LEADS_PER_YEAR_MONTH_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/total-leads-per-year-month-day";
    static REACT_APP_URL_PARTNERRFP_AFFILIATE_TOTAL_LEADS_PER_BUSINESS_TYPE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/affiliate-total-leads-per-business-type";
    static REACT_APP_URL_PARTNERRFP_AFFILIATE_PARTNERRFP_REJECT_LEADS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/reject-leads-affiliate";
    static REACT_APP_URL_PARTNERRFP_AFFILIATE_LEADS_LAST_3_MONTHS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/affiliate-leads-last-3-months";
    static REACT_APP_URL_PARTNERRFP_AFFILIATE_LEADS_PER_CATEGORY_UTM_WITH_REVSHARE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/affiliate-category-utm-with-revs";
    static REACT_APP_URL_PARTNERRFP_AFFILIATE_LEADS_PROFITABILITY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/affiliate-profitability";
    static REACT_APP_URL_PARTNERRFP_AFFILIATE_LEADS_PROFITABILITY_TABLE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/affiliate-profitability-table";
    static REACT_APP_URL_PARTNERRFP_AFFILIATE_LEADS_PROFITABILITY_TABLE_LEAD_RATIO: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/affiliate-profitability-table-lead-ratio";
    static REACT_APP_URL_PARTNERRFP_ACTIVE_SUPPLIER_COUNT: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/active-supplier-count";
    static REACT_APP_URL_PARTNERRFP_AFFILIATE_PROFIT_EVOLUTION: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/affiliate-profit-evolution";
    static REACT_APP_URL_PARTNERRFP_AFFILIATE_STALE_STATUS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/affiliate-stale-status";
    static REACT_APP_URL_PARTNERRFP_AFFILIATE_LEADS_REPORTS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/reports";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_SITE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-site";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_SITE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-site-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_SITE_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-site-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_AFFILIATE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-affiliate-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_AFFILIATE_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-affiliate-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_REVENUE_PER_AFFILIATE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-revenue-per-affiliate-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_REVENUE_PER_AFFILIATE_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-revenue-per-affiliate-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_REVENUE_PER_SOURCE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-revenue-per-source-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_REVENUE_PER_SOURCE_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-revenue-per-source-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_REVENUE_PER_BUSINESS_TYPE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-revenue-per-business-type-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_REVENUE_PER_BUSINESS_TYPE_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-revenue-per-business-type-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_SOURCE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-source-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_SOURCE_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-source-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_SITE_BY_UTM_SOURCE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-site-by-utm-source";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_SITE_BY_REM_SOURCE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-site-by-rem-source";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_UTM_SOURCE_PER_SITE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-utm-source-per-site-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_REM_SOURCE_PER_SITE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-rem-source-per-site-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_REM_SOURCES_FOR_UTM_SOURCE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-rem-sources-for-utm-source";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_UTM_SOURCES_FOR_REM_SOURCE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-utm-sources-for-rem-source";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_SITE_BY_BUSINESS_TYPE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-site-by-business-type-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_SITE_BY_BUSINESS_TYPE_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-site-by-business-type-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_SITE_BY_REJECTION_REASON_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-site-by-rejection-reason-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_UTM_SOURCE_REJECTION_REASONS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-utm-source-rejection-reasons";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_PER_REM_SOURCE_REJECTION_REASONS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-per-rem-source-rejection-reasons";

    // Per-Affiliate Statistics
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_PER_YEAR: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-per-year";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_PER_QUARTER: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-per-quarter";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_GROUP_AFF: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-groupe-aff";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_GROUP_AFF_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-groupe-aff-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_GROUP_AFF_PER_YEAR: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-groupe-aff-per-year";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_GROUP_AFF_PER_QUARTER: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-groupe-aff-per-quarter";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_GROUP_AFF_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-groupe-aff-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_GROUP_AFF_REVENUE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-groupe-aff-revenue-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_GROUP_AFF_REVENUE_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-groupe-aff-revenue-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_MARKETING_CHANNEL_REVENUE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-marketing-channel-revenue-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_MARKETING_CHANNEL_REVENUE_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-marketing-channel-revenue-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_DAY_PER_HOUR: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-day-per-hour";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_MARKETING_CHANNEL_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-marketing-channel-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_MARKETING_CHANNEL_PER_YEAR: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-marketing-channel-per-year";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_MARKETING_CHANNEL_PER_QUARTER: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-marketing-channel-per-quarter";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_MARKETING_CHANNEL_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-marketing-channel-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_MARKETING_CHANNEL: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-marketing-channel";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_BY_UTM_SOURCE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-by-utm-source-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_BY_REM_SOURCE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-by-rem-source-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_BY_BUSINESS_TYPE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-by-business-type-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_BY_BUSINESS_TYPE_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-by-business-type-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_BY_BUSINESS_TYPE_PER_QUARTER: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-by-business-type-per-quarter";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_BY_BUSINESS_TYPE_PER_YEAR: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-by-business-type-per-year";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_GROUP_AFF_BY_BUSINESS_TYPE_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-groupe-aff-by-business-type-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_GROUP_AFF_BY_BUSINESS_TYPE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-groupe-aff-by-business-type-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_GROUP_AFF_BY_BUSINESS_TYPE_PER_QUARTER: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-groupe-aff-by-business-type-per-quarter";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_GROUP_AFF_BY_BUSINESS_TYPE_PER_YEAR: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-groupe-aff-by-business-type-per-year";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_MARKETING_CHANNEL_BY_BUSINESS_TYPE_PER_DAY: string =
        this.APP_API_URL_BACKEND() +
        "/v1/rest-api/partner-rfp/statistics/per-marketing-channel-by-business-type-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_MARKETING_CHANNEL_BY_BUSINESS_TYPE_PER_MONTH: string =
        this.APP_API_URL_BACKEND() +
        "/v1/rest-api/partner-rfp/statistics/per-marketing-channel-by-business-type-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_MARKETING_CHANNEL_BY_BUSINESS_TYPE_PER_QUARTER: string =
        this.APP_API_URL_BACKEND() +
        "/v1/rest-api/partner-rfp/statistics/per-marketing-channel-by-business-type-per-quarter";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_MARKETING_CHANNEL_BY_BUSINESS_TYPE_PER_YEAR: string =
        this.APP_API_URL_BACKEND() +
        "/v1/rest-api/partner-rfp/statistics/per-marketing-channel-by-business-type-per-year";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_BY_REJECTION_REASON_PER_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-by-rejection-reason-per-month";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_BY_REJECTION_REASON_PER_DAY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-by-rejection-reason-per-day";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_BY_REJECTION_REASON_PER_QUARTER: string =
        this.APP_API_URL_BACKEND() +
        "/v1/rest-api/partner-rfp/statistics/per-affiliate-by-rejection-reason-per-quarter";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_BY_REJECTION_REASON_PER_YEAR: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/per-affiliate-by-rejection-reason-per-year";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_BY_UTM_SOURCE_REJECTION_REASONS: string =
        this.APP_API_URL_BACKEND() +
        "/v1/rest-api/partner-rfp/statistics/per-affiliate-by-utm-source-rejection-reasons";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PER_AFFILIATE_BY_REM_SOURCE_REJECTION_REASONS: string =
        this.APP_API_URL_BACKEND() +
        "/v1/rest-api/partner-rfp/statistics/per-affiliate-by-rem-source-rejection-reasons";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEO_ALERTS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/seo-alerts";

    // Revenues Per Day Category Statistics
    static REACT_APP_URL_PARTNERRFP_STATISTICS_REVENUES_YEARLY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/revenues-per-day-category/yearly";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_REVENUES_MONTHLY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/revenues-per-day-category/monthly";

    // SEA revenues per premium category per language
    static REACT_APP_URL_PARTNERRFP_STATISTICS_SEA_CHANNEL_STATS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/sea-channel-stats";

    // Premium Category Top-Yearly Statistics (Leads per category â€” top yearly)
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PREMIUM_CATEGORY_TOPYEARLY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/premium-category-topyearly";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PREMIUM_CATEGORY_MONTHLY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/premium-category-topyearly/monthly";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PREMIUM_CATEGORY_REGIONS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/premium-category-topyearly/regions";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PREMIUM_CATEGORY_FILTERS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/premium-category-topyearly/filters";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PREMIUM_CATEGORY_FILTER_CATEGORIES: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/premium-category-topyearly/filter-categories";

    // Yearly leads per country (migrated gchart_pppleads_yearly). One request per country/tab.
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PPP_LEADS_YEARLY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/ppp-leads-yearly";
    // Protests by affiliate group (migrated gchart_aff_protests, REBO-623)
    static REACT_APP_URL_PARTNERRFP_STATISTICS_AFF_PROTESTS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/aff-protests";

    // Protest table and the two raw exports carrying the lead acquisition context (REBO-979)
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PROTEST_EXPORT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/protest-export";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PROTEST_EXPORT_TABLE: string = this.REACT_APP_URL_PARTNERRFP_STATISTICS_PROTEST_EXPORT + "/table";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PROTEST_EXPORT_PROTESTS_FILE: string = this.REACT_APP_URL_PARTNERRFP_STATISTICS_PROTEST_EXPORT + "/protests/file";
    static REACT_APP_URL_PARTNERRFP_STATISTICS_PROTEST_EXPORT_DELIVERED_FILE: string = this.REACT_APP_URL_PARTNERRFP_STATISTICS_PROTEST_EXPORT + "/delivered-leads/file";

    // Premium leads / LR / price / revenue per lead, per country and period (migrated monthly_global_rfps, REBO-634)
    static REACT_APP_URL_PARTNERRFP_STATISTICS_MONTHLY_GLOBAL_RFPS_PER_COUNTRY: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/monthly-global-rfps/per-country";

    // Accepted "multiple" leads per month and marketing channel (migrated gchart_monthly_accepted_multiples, REBO-622)
    static REACT_APP_URL_PARTNERRFP_STATISTICS_ACCEPTED_MULTIPLES_PER_CHANNEL: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/accepted-multiples-per-channel";
    // Accepted "multiple" leads per month and originating category (second tab of the same page, REBO-975)
    static REACT_APP_URL_PARTNERRFP_STATISTICS_ACCEPTED_MULTIPLES_PER_CATEGORY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-rfp/statistics/accepted-multiples-per-category";

    // Monthly Global KPI â€” channel-margin grid (REBO-841). Instance slice; per-country = BE aggregator. Pure KPI.
    static REACT_APP_URL_CHANNEL_KPI_INSTANCE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/channel-kpi/instance";
    static REACT_APP_URL_CHANNEL_KPI_PER_COUNTRY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/channel-kpi/per-country";
    static REACT_APP_URL_CHANNEL_KPI_CHANNEL_ORDER: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/channel-kpi/channel-order";
    // Full legacy dense KPI table (single country); per-country = BE aggregator (BE local + NL/CI fan-out).
    static REACT_APP_URL_CHANNEL_KPI_FULL_PER_COUNTRY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/channel-kpi/full-per-country";

    // Monthly Revenue Targets â€” actual-vs-target pivot tables (REBO-592). Local = per-vendor (own country);
    // Global = per-country + brands (BE aggregator, fan-out). Replaces legacy monthly_targets / monthly_global_targets.
    static REACT_APP_URL_MONTHLY_TARGETS_LOCAL: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/monthly-targets/local";
    static REACT_APP_URL_MONTHLY_TARGETS_GLOBAL: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/monthly-targets/global";

    // Invoices by vendor â€” monthly-targets cell drill-down (REBO-592). Replaces legacy list_invoices_vendor.
    static REST_API_INVOICES_BY_VENDOR_ENDPOINT: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices-by-vendor";
    static REST_API_INVOICES_BY_VENDOR_SEARCH: string = this.REST_API_INVOICES_BY_VENDOR_ENDPOINT + "/search";
    static REST_API_INVOICES_BY_VENDOR_TOTAL: string = this.REST_API_INVOICES_BY_VENDOR_ENDPOINT + "/total";

    static REST_API_EXPERT_ROLE_MODEL_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role";
    static REACT_APP_URL_EXPERT_ROLE_CATEGORIES: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/categories";
    static REACT_APP_URL_EXPERT_ROLE_UPDATE_SYSTEM_PRICING: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/update-price-system";
    static REACT_APP_URL_EXPERT_ROLE_CHANGE_VENDOR: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/change-vendor";
    static REACT_APP_URL_EXPERT_ROLE_INVOICES_FOR_STARS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/invoices-for-stars";
    static REACT_APP_URL_EXPERT_ROLE_CREDIT_NOTES_FOR_STARS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/credit-notes-for-stars";
    static REACT_APP_URL_EXPERT_ROLE_SUPPLIER_STARS_DATA: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/supplier-stars-data";
    static REACT_APP_URL_EXPERT_ROLE_SUPPLIER_STARS_DATA_BULK: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/supplier-stars-data/bulk";
    static REACT_APP_URL_EXPERT_ROLE_MONTHLY_SUBMISSIONS_COUNT: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/monthly-submissions-count";
    static REACT_APP_URL_EXPERT_ROLE_YEARLY_SUBMISSIONS_COUNT: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/yearly-submissions-count";
    static REACT_APP_URL_EXPERT_ROLE_PROTEST_RATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/protest-rate";
    static REACT_APP_URL_EXPERT_ROLE_EVALUATION: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/score";
    static REACT_APP_URL_EXPERT_ROLE_PHONE_HLR_VALIDATION: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/phonenumber-hlr-validation";
    static REACT_APP_URL_EXPERT_ROLE_PHONE_SMS_VALIDATION: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/phonenumber-sms-validation";
    static REACT_APP_URL_EXPERT_ROLE_COUNT_MARKETING_INVOICES: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/count-marketing-fee-invoices";
    static REST_API_EXPERTBUSINESSTYPE_MODEL_ENDPOINT: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-business-types";
    // Integration visibility (REBO-935): dispatch-log errors + per-supplier config
    static REST_API_PARTNERRFP_INTEGRATION_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/partnerrfp-integration";
    static REST_API_EXPERTROLE_INTEGRATION_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role-integration";
    static REST_API_EXPERTBUSINESSTYPE_HISTORY_MODEL_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-business-types-history";
    static REST_API_PRESENCE_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/presence";
    static REST_API_NOTIFICATION_MODEL_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/notification";
    static REACT_APP_URL_EXPERT_BUSINESS_TYPES_DELETE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-business-types/delete";
    static REACT_APP_URL_CONTRACT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/contract";
    static REACT_APP_URL_CONTRACT_CREATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/contract/create";
    static REACT_APP_URL_CONTRACT_DELETE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/contract/delete";
    static REACT_APP_URL_CONTRACT_COUNT: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/contract/check-one-contract";
    static REACT_APP_URL_BUSINESS_TYPES: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/business-types";
    static REACT_APP_URL_COMPANY_HISTORY: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/company-history";
    static REACT_APP_URL_REGIONS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/regions";
    static REACT_APP_URL_PDF_EXPORT_TASK: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/pdf-export-task";
    static REACT_APP_URL_INVOICE_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices";
    static REACT_APP_URL_INVOICE_LIST_ALL: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/all";
    static REACT_APP_URL_INVOICE_SEND_BY_EMAIL: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/send-invoice-email";
    static REACT_APP_URL_INVOICES_SEND_BY_BATCH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/send-invoices-batch";
    static REACT_APP_URL_UBL_SEND_TO_PEPPOL: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/ubl-send/send-to-peppol";
    static REACT_APP_URL_UBL_SEND_CREDIT_RECORDS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/ubl-send/credit";
    static REACT_APP_URL_UBL_SEND_CREDIT_TO_PEPPOL: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/ubl-send/send-credit-to-peppol";
    static REACT_APP_URL_INVOICE_UBL_SEND_RECORDS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/ubl-send-records";
    static REACT_APP_URL_INVOICE_YEARLY_STATS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/yearly-stats";
    static REACT_APP_URL_INVOICE_MONTHLY_STATS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/monthly-stats";
    static REACT_APP_URL_INVOICE_HAS_AT_LEAST_ONE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/has-at-least-one";
    static REACT_APP_URL_INVOICE_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices";
    static REACT_APP_URL_INVOICE_CREATE: string = this.REACT_APP_URL_INVOICE_ENDPOINT + "/create";
    static REACT_APP_URL_INVOICE_UPDATE = (id: number): string => {
        return this.REACT_APP_URL_INVOICE_ENDPOINT + "/" + id + "/update";
    };
    static REACT_APP_URL_INVOICE_DELETE = (id: number): string => {
        return this.REACT_APP_URL_INVOICE_ENDPOINT + "/" + id + "/delete";
    };
    static REACT_APP_URL_INVOICE_CREATE_MRKT_FEE: string = this.REACT_APP_URL_INVOICE_ENDPOINT + "/create/mrktfee";
    static REACT_APP_URL_INVOICE_CREATE_FINAL: string = this.REACT_APP_URL_INVOICE_ENDPOINT + "/save";
    static REACT_APP_URL_INVOICE_DETAILS = (id: number): string => {
        return this.REACT_APP_URL_INVOICE_ENDPOINT + "/" + id + "/details";
    };
    static REACT_APP_URL_INVOICE_DOWNLOAD_INVOICE = (id: number): string => {
        return this.REACT_APP_URL_INVOICE_ENDPOINT + "/" + id + "/downloadInvoicePdf";
    };
    static REACT_APP_URL_INVOICE_SHOW = (id: number): string => {
        return this.REACT_APP_URL_INVOICE_ENDPOINT + "/" + id + "/showInvoice";
    };
    static REACT_APP_URL_REMINDER_INVOICE_SHOW: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/showReminder";
    static REACT_APP_URL_REMINDER_INVOICE_DOWNLOAD: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/downloadInvoiceReminderPdf";
    static REACT_APP_URL_REMINDER_INVOICE_RENEW_MKT_FEE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/renew-marketing-fee";
    static REACT_APP_URL_INVOICE_SEARCH_RENEWALS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/search-renewals";
    static REACT_APP_URL_INVOICE_RENEWALS_YEAR_MONTHS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/renewals/year-months";
    static REACT_APP_URL_INVOICE_NOT_RENEW_MKT_FEE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoices/not-renew-marketing-fee";
    static REACT_APP_URL_INVOICE_CREDIT_NOTE_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/credit-note";
    static REACT_APP_URL_INVOICE_CREDIT_NOTE_CREATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/credit-note/create";
    static REACT_APP_URL_INVOICE_CREDIT_NOTE_UPDATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/credit-note/update";
    static REACT_APP_URL_INVOICE_CREDIT_NOTE_DOWNLOAD: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/credit-note/download-credit-note-to-pdf";
    static REACT_APP_URL_INVOICE_CREDIT_NOTE_SHOW: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/credit-note/credit-note-template";
    static REACT_APP_URL_CREDIT_NOTE_LIST: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/credit-note/list";
    static REACT_APP_URL_CREDIT_NOTE_SEND_BY_EMAIL: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/credit-note/send-email";
    static REACT_APP_URL_CREDIT_NOTE_SEND_TO_ODOO: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/credit-note/send-to-odoo";
    static REACT_APP_URL_SUBSCRIPTION_STATUS_READ: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/subscription-status";
    static REACT_APP_URL_INVOICE_TYPE_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/invoice-type";
    static REACT_APP_URL_INVOICE_ACCT_LINE_ENDPOINT: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/invoice-acct-line";
    static REACT_APP_URL_INVOICE_ACCT_LINE_CREATE: string = this.REACT_APP_URL_INVOICE_ACCT_LINE_ENDPOINT + "/create";
    static REACT_APP_URL_INVOICE_ACCT_LINE_UPDATE = (id: number): string => {
        return this.REACT_APP_URL_INVOICE_ACCT_LINE_ENDPOINT + "/" + id + "/update";
    };
    static REACT_APP_URL_INVOICE_ACCT_LINE_DELETE = (id: number): string => {
        return this.REACT_APP_URL_INVOICE_ACCT_LINE_ENDPOINT + "/" + id + "/delete";
    };
    static REACT_APP_URL_RAPPEL_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/rappel";
    static REACT_APP_URL_RAPPEL_SEARCH_LAST_LETTER: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/rappel/search-last-letter";
    static REACT_APP_URL_RAPPEL_COUNT_ALL_LAST: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/rappel/count-all-last";
    static REACT_APP_URL_RAPPEL_LABELS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/rappel/labels";
    static REACT_APP_URL_RAPPEL_PRINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/rappel/print";
    static REACT_APP_URL_RAPPEL_GENERATE_ALL_LAST: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/rappel/generate-all-last";
    static REST_API_URL_CRM_COMMENT_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/crm";
    static REST_API_URL_CRM_COMMENT_CREATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/crm/create";
    static REST_API_URL_CRM_COMMENT_DETAILS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/crm/details";
    static REST_API_URL_CRM_COMMENT_COUNT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/crm/check-one-comment";
    static REST_API_URL_CRM_CATEGORY_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/crm-category";
    static REST_API_URL_CRM_STATUS_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/crm-status";
    static REST_API_URL_OPPORTUNITY: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/opportunity";
    static REST_API_URL_OPPORTUNITY_CREATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/opportunity/create";
    static REST_API_URL_OPPORTUNITY_UPDATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/opportunity/update";
    static REST_API_URL_OPPORTUNITY_SALES_DASHBOARD: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/opportunity/sales-dashboard";
    static REST_API_URL_ASSIGNATION_SALES: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/assignation-sales";
    static REST_API_URL_ASSIGNATION_SALES_CREATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/assignation-sales/create";
    static REST_API_URL_ASSIGNATION_SALES_UPDATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/assignation-sales/update";
    static REST_API_URL_ASSIGNATION_SALES_UPDATE_STATUS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/assignation-sales/update-status";
    static REST_API_URL_ASSIGNATION_SALES_YEAR_MONTH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/assignation-sales/year-month";
    static REST_API_URL_ASSIGNATION_SALES_PROSPECTS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/assignation-sales/my-prospects";
    static REST_API_URL_ASSIGNATION_SALES_PROSPECTS_COUNTER: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/assignation-sales/my-prospects-counter";
    static REACT_API_URL_ASSIGNATION_SALES_SEARCH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/assignation-sales/search";
    static REST_API_URL_INDUSTRY_AREA_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/industry-area";
    static REST_API_URL_ADMINISTRATOR: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/administrator";
    static REST_API_URL_ADMINISTRATOR_CREATE: string = this.REST_API_URL_ADMINISTRATOR + "/create";
    static REST_API_URL_ADMINISTRATOR_SALES_LIST: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/administrator/sales";
    static REST_API_URL_ADMINISTRATOR_PREMIUM_VENDORS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/administrator/premium-vendors";
    static REACT_APP_URL_ADMIN_SEARCH: string = this.REST_API_URL_ADMINISTRATOR + "/search";
    static REST_API_URL_COUNTRY_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/country";
    static REST_API_URL_VAT_CHECKER: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/vat/check";
    static REST_API_URL_TRANSLATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/translation/translate";
    static REST_API_CALL_VALIDATION_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/call-validation";
    static REACT_APP_URL_THREEXCX_CALL_BY_LEAD: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/3cx/by-lead/";
    static REACT_APP_URL_THREEXCX_CALL_BY_MEMBER: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/3cx/by-member/";
    static REST_API_URL_NEWSLETTER: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/newsletter";
    static REACT_APP_URL_NEWSLETTER_SEARCH: string = this.REST_API_URL_NEWSLETTER + "/search";
    static REACT_APP_URL_NEWSLETTER_DELETE: string = this.REST_API_URL_NEWSLETTER + "/delete";
    static REACT_APP_URL_NEWSLETTER_SAVE: string = this.REST_API_URL_NEWSLETTER + "/save";
    static REACT_APP_URL_NEWSLETTER_BULK_UPDATE_STATUS: string = this.REST_API_URL_NEWSLETTER + "/bulk-update-status";
    static REACT_APP_URL_NEWSLETTER_UPLOAD_THUMBNAIL: string = this.REST_API_URL_NEWSLETTER + "/upload-thumbnail";
    static REST_API_URL_EMAIL_REDLIST: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/email-redlist";
    static REST_API_URL_EMAIL_REDLIST_SEARCH: string = this.REST_API_URL_EMAIL_REDLIST + "/search";
    static REACT_APP_URL_EMAIL_REDLIST_UPDATE =(id: number) => this.REST_API_URL_EMAIL_REDLIST + `/${id}`;
    static REST_API_URL_TIKTOK_REPORTING: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/tiktok-reporting";
    static REST_API_URL_ADWORDS_REPORTING: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/adwords-reporting";
    static REST_API_URL_BING_REPORTING: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/bing-reporting";
    static REST_API_URL_FACEBOOK_REPORTING: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/facebook-reporting";
    static REST_API_URL_TABOOLA_REPORTING: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/taboola-reporting";
    static REST_API_URL_BUSINESS_TYPE_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/business-types/get-all";
    static REST_API_URL_BUSINESS_TYPE_PARTNER: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/business-types/get-partnertypes";
    static REST_API_URL_BUSINESS_TYPE_PARTNER_FOR_CONFIG: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/business-types/get-partnertypes-for-config";
    static REST_API_URL_BUSINESS_TYPE_AUTOCOMPLETE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/business-types/search/autocomplete";
    static REST_API_URL_BUSINESS_TYPE_PARENTS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/business-types/get-parents";

    // Category endpoints
    static REST_API_URL_CATEGORIES: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/categories";
    static REST_API_URL_CATEGORIES_GET_ALL: string = this.REST_API_URL_CATEGORIES + "/get-all";
    static REST_API_URL_CATEGORIES_CREATE: string = this.REST_API_URL_CATEGORIES + "/create";
    static REST_API_URL_CATEGORIES_AUTOCOMPLETE: string = this.REST_API_URL_CATEGORIES + "/search/autocomplete";
    static REST_API_URL_CATEGORIES_BY_IDS: string = this.REST_API_URL_CATEGORIES + "/by-ids";

    // Template endpoints
    static REST_API_URL_TEMPLATES: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/templates/get-all";
    static REST_API_URL_AFFILIATE_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/affiliate";
    static REACT_APP_URL_AFFILIATE_AUTOCOMPLETE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/affiliate/search/autocomplete/";
    static REST_API_URL_AFFILIATE_PRICING_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/affiliate-pricing";
    static REST_API_URL_AFFILIATE_PRICING_CREATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/affiliate-pricing/create";
    static REST_API_URL_AFFILIATE_PRICING_UPDATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/affiliate-pricing/update";
    static REST_API_URL_AFFILIATE_PRICING_TOGGLE_STATUS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/affiliate-pricing/delete";
    static REST_API_URL_AFFILIATE_PRICING_RECALCULATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/affiliate-pricing/recalculate";
    static REST_API_URL_AFFILIATE_PRICING_LIST: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/affiliate-pricing/list";
    static REST_API_URL_AFFILIATE_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/affiliate";
    static REST_API_URL_AFFILIATE_CODE_BY_MEMBER: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/affiliate/member";

    static REACT_APP_URL_MAILING_KIT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/mailing-kit";
    static REACT_APP_URL_MAILING_KIT_ADD: string = this.REACT_APP_URL_MAILING_KIT + "/add";
    static REACT_APP_URL_MAILING_KIT_TOGGLE_STATUS: string = this.REACT_APP_URL_MAILING_KIT + "/toggle-status";
    static REACT_APP_URL_JODIT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/jodit";
    static REST_API_URL_USER_EMAIL_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/user-email";
    static REST_API_URL_USER_EMAIL_CREATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/user-email/create";
    static REST_API_URL_USER_EMAIL_UPDATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/user-email/update";
    static REST_API_URL_USER_EMAIL_DELETE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/user-email/delete";
    static REST_API_URL_USER_EMAIL_DETAILS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/user-email/details";
    static REST_API_URL_EXPERT_FREE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-free";
    static REST_API_URL_EXPERT_FREE_CREATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-free/create";
    static REST_API_URL_FREE_LEAD_INVOICING_SUMMARY: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/free-lead-invoicing/summary";
    static REST_API_URL_FREE_LEAD_INVOICING_PREPARE_PREVIEW: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/free-lead-invoicing/prepare/preview";
    static REST_API_URL_FREE_LEAD_INVOICING_PREPARE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/free-lead-invoicing/prepare";
    static REST_API_URL_FREE_LEAD_INVOICING_REVERSE_PREVIEW: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/free-lead-invoicing/reverse-over-allocation/preview";
    static REST_API_URL_FREE_LEAD_INVOICING_REVERSE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/free-lead-invoicing/reverse-over-allocation";
    static REST_API_URL_FREE_LEAD_INVOICING_CLOSE_OUT_ELIGIBLE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/free-lead-invoicing/close-out/eligible";
    static REST_API_URL_FREE_LEAD_INVOICING_CLOSE_OUT: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/free-lead-invoicing/close-out";
    // Batch lead(-fee) invoicing (free-lead prep is only one input); real invoice creation lands here later.
    static REST_API_URL_LEAD_INVOICING_SIMULATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/lead-invoicing/simulate";
    static REST_API_URL_LEAD_INVOICING_SIMULATE_PDF: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/lead-invoicing/simulate/pdf";
    // Real invoice generation (write pass) â€” gated by its own GENERATE_LEAD_INVOICES authority.
    static REST_API_URL_LEAD_INVOICING_CREATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/lead-invoicing/create";
    // Twikey mandate export: preview/download the SEPA collection CSVs uploaded to Twikey manually.
    static REST_API_URL_TWIKEY_EXPORT_BATCH_DATES: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/twikey-export/batch-dates";
    static REST_API_URL_TWIKEY_EXPORT_ROWS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/twikey-export/rows";
    static REST_API_URL_TWIKEY_EXPORT_CSV: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/twikey-export/csv";
    static REST_API_URL_BANK_CREATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/bank/create";
    static REST_API_URL_BANK_DEFAULT_MANDATE_ID = (supplierId: number): string =>
        this.APP_API_URL_BACKEND() + "/v1/rest-api/bank/default-mandate-id/" + supplierId;
    static REST_API_URL_TWIKEY_INVITE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/twikey/invite";
    static REST_API_URL_STATISTICS_PARTNER_SUBMISSION_YEAR_MONTH =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/statistics/year-month";
    static REST_API_URL_PARTNERSUBMISSION_SUPPLIER_LEADS = (supplierId: number): string =>
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/supplier/" + supplierId + "/leads";
    static REST_API_URL_STATISTICS_EXPERT_ROLE_COUNT_PER_MONTH =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/statistics/expert-role";
    static REST_API_URL_STATISTICS_LEADS_PER_REGION_YTD =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/statistics/leads-per-region-ytd";
    static REST_API_URL_STATISTICS_LEADS_PER_CATEGORY_YTD =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/statistics/leads-per-category-ytd";
    static REST_API_URL_STATISTICS_PROTESTS_PER_REASON_YTD =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/statistics/protests-per-reason-ytd";
    static REST_API_URL_STATISTICS_PROTESTS_ONLY_ONES_YTD =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/statistics/protests-only-ones-ytd";
    static REST_API_URL_STATISTICS_COMPETITORS_PER_ML_YTD =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/statistics/competitors-per-ml-ytd";
    static REST_API_URL_PARTNER_SUBMISSION_FOR_PARTNER_RFP =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/for-partner-rfp";
    static REST_API_URL_PARTNERSUBMISSION_BAD_EMAIL =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/bad-email";
    static REST_API_URL_PARTNERSUBMISSION_NOT_INTERESTED =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/not-interested";
    static REST_API_URL_PARTNERSUBMISSION_NOT_INTERESTED_ALL_OPERATORS =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/not-interested/operators";
    static REST_API_URL_PARTNERSUBMISSION_NOT_INTERESTED_VERDICT_COUNTS =
        this.REST_API_URL_PARTNERSUBMISSION_NOT_INTERESTED + "/verdict-counts";
    static REST_API_URL_PARTNERSUBMISSION_NOT_INTERESTED_REVIEW_CONTEXT =
        this.REST_API_URL_PARTNERSUBMISSION_NOT_INTERESTED + "/review-context";
    static REST_API_URL_PARTNER_SUBMISSION_LEAD_PRICE = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission";
    static REST_API_URL_PARTNERPREMIUMPRICING_OPTIONS =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-premium-pricing/pricing-options";
    static REST_API_URL_PARTNERSUBMISSION_WITHOUT_PRICE =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission/without-price";
    static REST_API_URL_PARTNERSUBMISSION = this.APP_API_URL_BACKEND() + "/v1/rest-api/partner-submission";
    static REST_API_URL_USER_INTEREST_SAVE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/user-interest/save";
    static REST_API_URL_USER_INTEREST: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/user-interest";
    static REST_API_URL_TESTIMONIAL_MODEL_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/testimonial";
    static REST_API_URL_TESTIMONIAL_MODEL_SAVE: string = this.REST_API_URL_TESTIMONIAL_MODEL_READ + "/save";
    static REST_API_URL_TESTIMONIAL_MODEL_DELETE: string = this.REST_API_URL_TESTIMONIAL_MODEL_READ + "/delete";
    static REST_API_URL_MEMBERAFFILIATE_REPORTS_MODEL_ADD: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/member-affiliate-reports/add";
    static REST_API_URL_COST_MODEL_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/cost";
    static REST_API_URL_COST_MODEL_LIST: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/cost/list";
    static REST_API_URL_COST_MODEL_CREATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/cost/create";
    static REST_API_URL_COST_MODEL_UPDATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/cost/update";
    static REST_API_URL_COST_MODEL_CREATE_CREDIT_INVOICE = (id: number): string => {
        return this.REST_API_URL_COST_MODEL_READ + "/" + id + "/credit-invoice";
    };
    static REST_API_URL_COST_MODEL_SHOW_CREDIT_INVOICE = (id: number): string => {
        return this.REST_API_URL_COST_MODEL_READ + "/" + id + "/showCreditInvoice";
    };
    static REST_API_URL_COST_MODEL_DOWNLOAD_CREDIT_INVOICE = (id: number): string => {
        return this.REST_API_URL_COST_MODEL_READ + "/" + id + "/downloadCreditInvoicePdf";
    };
    static REST_API_URL_MEMBER_CONTACT_MODEL_CREATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/member-contact/create";
    static REST_API_URL_MEMBER_CONTACT_MODEL_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/member-contact";
    static REST_API_URL_MEMBER_CONTACT_MODEL_UPDATE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/member-contact/update";
    static REST_API_URL_MEMBER_CONTACT_MODEL_DELETE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/member-contact/delete";
    static REACT_APP_URL_RECENT_READ: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/recent/history";
    static REACT_APP_URL_RECENT_ADD: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/recent/add";

    static REAST_API_URL_PIXEL: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/pixel";
    static REAST_API_URL_PIXEL_LOG: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/pixel-log";

    //buyer
    static REST_API_URL_BUYER_INTEREST_READ: string = this.APP_API_URL_BACKEND() + "/v1/buyer/interests";

    // Statistics
    static REST_API_URL_STATISTICS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/statistics";
    static REST_API_URL_STATISTICS_LEADS_12_MONTHS: string = this.REST_API_URL_STATISTICS + "/leads-12-months/";
    static REST_API_URL_STATISTICS_LEADS_FOR_PERIOD: string = this.REST_API_URL_STATISTICS + "/leads-for-period/";
    static REST_API_URL_STATISTICS_LEADS_PER_AFF: string = this.REST_API_URL_STATISTICS + "/leads-per-aff/";
    static REST_API_URL_STATISTICS_LEADS_PER_CATEG_UTM: string = this.REST_API_URL_STATISTICS + "/leads-per-categ-utm/";
    static REST_API_URL_STATISTICS_LEADS_REJECTED_BY_REASON: string =
        this.REST_API_URL_STATISTICS + "/leads-rejected-by-reason/";
    static REST_API_URL_STATISTICS_LEADS_REGISTERED_FOR_PERIOD: string =
        this.REST_API_URL_STATISTICS + "/leads-registered-for-period/";

    // Dashboard
    static REST_API_URL_DASHBOARD: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/dashboard";
    static REST_API_URL_DASHBOARD_PREMIUM_LEADS: string = this.REST_API_URL_DASHBOARD + "/premium-leads";
    static REST_API_URL_DASHBOARD_UPCOMING_BIRTHDAYS: string = this.REST_API_URL_DASHBOARD + "/upcoming-birthdays";
    static REST_API_URL_DASHBOARD_OPEN_LEAD_FEES: string = this.REST_API_URL_DASHBOARD + "/open-lead-fees";
    static REST_API_URL_DASHBOARD_OPEN_PROTESTS: string = this.REST_API_URL_DASHBOARD + "/open-protests";
    static REST_API_URL_DASHBOARD_LEAD_FEE_TARGET: string = this.REST_API_URL_DASHBOARD + "/lead-fee-target";
    static REST_API_URL_DASHBOARD_SALES_DATA: string = this.REST_API_URL_DASHBOARD + "/sales-data";

    // Global sales dashboard (migrated from legacy bo_dashboard_sales_global) â€” kept apart from
    // /dashboard so the two legacy pages never share a route.
    static REST_API_URL_GLOBAL_DASHBOARD: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/global-dashboard";
    static REST_API_URL_GLOBAL_DASHBOARD_SALES_BY_VENDOR: string =
        this.REST_API_URL_GLOBAL_DASHBOARD + "/sales-by-vendor";
    static REST_API_URL_GLOBAL_DASHBOARD_SALES_BY_COUNTRY: string =
        this.REST_API_URL_GLOBAL_DASHBOARD + "/sales-by-country";
    static REST_API_URL_GLOBAL_DASHBOARD_PREMIUM_VENDORS: string =
        this.REST_API_URL_GLOBAL_DASHBOARD + "/premium-vendors";

    // Incentives dashboard (migrated from legacy bo_dashboard_inc)
    static REST_API_URL_INCENTIVE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/incentive-kpi";
    static REST_API_URL_INCENTIVE_MKT: string = this.REST_API_URL_INCENTIVE + "/mkt-incentive";
    static REST_API_URL_INCENTIVE_SALES: string = this.REST_API_URL_INCENTIVE + "/sales-incentive";
    static REST_API_URL_INCENTIVE_VALIDATION: string = this.REST_API_URL_INCENTIVE + "/validation-incentive";
    static REST_API_URL_INCENTIVE_PEOPLE: string = this.REST_API_URL_INCENTIVE + "/people";
    static REST_API_URL_INCENTIVE_ACCOUNT_MANAGER: string = this.REST_API_URL_INCENTIVE + "/account-manager-incentive";
    static REST_API_URL_INCENTIVE_IT: string = this.REST_API_URL_INCENTIVE + "/it-incentive";

    static REST_API_URL_LEAD_SIMULATION: string = this.REST_API_EXPERTBUSINESSTYPE_MODEL_ENDPOINT + "/lead-simulation";

    static REST_API_TEAM_MEMBER_MODEL_ENDPOINT = (accountId: number): string => {
        if (accountId === undefined || accountId === null) {
            throw new Error("userId is required");
        }
        return this.APP_API_URL_BACKEND() + "/v1/rest-api/user/" + accountId + "/team-member";
    };
    static REST_API_URL_SUPPLIER_ZIP: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/zip";
    static REST_API_URL_ZIP_DISTANCE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/zip-distance";
    static REST_API_URL_PPP_SUPPLIERS_REGION: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/ppp-suppliers-region";

    static REST_API_EXTRANET_FOLDER_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/extranet-folder";

    static REST_API_EXPERT_BUSINESS_TYPE_TEMPLATE_FILTER_MODEL_ENDPOINT: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-business-type-template-filter";

    static REST_API_MEMBER_HISTORY_ENDPOINT = this.APP_API_URL_BACKEND() + "/v1/rest-api/member-history";
    static REST_API_EXPERT_ROLE_HISTORY_ENDPOINT = this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role-history";
    static REST_API_PARTNERS_HOLIDAYS_HISTORY_ENDPOINT =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/partners-holidays-history";

    static REST_API_PARTNER_RFP_SPAM_ENDPOINT = this.APP_API_URL_BACKEND() + "/v1/rest-api/partnerrfp-spam";

    // TrustPilot
    static REST_API_URL_TRUSTPILOT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/trustpilot";

    // Holidays List (under expert-role)
    static REST_API_HOLIDAYS_LIST_ENDPOINT = this.APP_API_URL_BACKEND() + "/v1/rest-api/expert-role/holidays";

    // Govex
    static REST_API_GOVEXPROFILE_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/govex-profile";
    static REACT_APP_URL_GOVEXPROFILE_SEARCH: string = this.REST_API_GOVEXPROFILE_ENDPOINT + "/search";

    static REST_API_GOVEXSUBSCRIPTION_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/govex-subscription";
    static REACT_APP_URL_GOVEXSUBSCRIPTION_SEARCH: string = this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + "/search";
    // Unified UBL send records endpoint (replaces invoice and subscription specific endpoints)
    static REACT_APP_URL_UBL_SEND_RECORDS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/ubl-send";
    // UBL invoice creation endpoint
    static REACT_APP_URL_UBL_INVOICE_CREATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/ubl/invoice";
    // UBL credit note creation endpoint (Bobex)
    static REACT_APP_URL_UBL_CREDIT_NOTE_CREATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/ubl/credit-note";
    // UBL credit note creation endpoint (Govex) - uses govex-subscription nested route
    static REACT_APP_URL_UBL_GOVEX_CREDIT_CREATE: (subscriptionId: number, creditId: number) => string = (
        subscriptionId,
        creditId,
    ) => this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + `/${subscriptionId}/credit/${creditId}/create-ubl`;
    static REACT_APP_URL_GOVEXSUBSCRIPTION_INVOICE: (subscriptionId: number) => string = (subscriptionId) =>
        this.APP_API_URL_BACKEND() + "/v1/rest-api/govex-subscription/" + subscriptionId + "/invoice";
    static REACT_APP_URL_GOVEXSUBSCRIPTION_INVOICE_PDF: (subscriptionId: number) => string = (subscriptionId) =>
        this.APP_API_URL_BACKEND() + "/v1/rest-api/govex-subscription/" + subscriptionId + "/invoice.pdf";

    // Invoice Group
    static REACT_APP_URL_INVOICE_GROUP: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/invoice-group";
    static REACT_APP_URL_INVOICE_GROUP_LIST: string = this.REACT_APP_URL_INVOICE_GROUP + "/list";
    static REACT_APP_URL_INVOICE_GROUP_LIST_ALL_COUNTRIES: string =
        this.REACT_APP_URL_INVOICE_GROUP + "/list/all-countries";

    static REACT_APP_URL_INVOICE_GROUP_LIST_PAST_DUE: string = this.REACT_APP_URL_INVOICE_GROUP + "/list-past-due";
    static REACT_APP_URL_INVOICE_GROUP_TOTALS: string = this.REACT_APP_URL_INVOICE_GROUP + "/totals";
    static REACT_APP_URL_INVOICE_GROUP_TOTALS_ALL_COUNTRIES: string =
        this.REACT_APP_URL_INVOICE_GROUP + "/totals/all-countries";
    static REACT_APP_URL_INVOICE_GROUP_NOT_RENEWAL: string = this.REACT_APP_URL_INVOICE_GROUP + "/not-renewal";

    static REACT_APP_URL_TOKENMODEL_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/token";
    static REACT_APP_URL_MEMBER_API_TOKEN_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/token/member-api";
    static REACT_APP_URL_MEMBER_API_LOG_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/member-api-log";

    // Lawyer
    static REST_API_URL_LAWYER: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/lawyer";
    // Lawyer
    static REACT_APP_URL_LAWYER_ENDPOINT: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/lawyer";
    static REACT_APP_URL_LAWYER_SEARCH_INVOICE_ACCT: string =
        this.REACT_APP_URL_LAWYER_ENDPOINT + "/search-invoice-acct";
    // static REACT_APP_URL_LAWYER_SEARCH_SUBSCRIPTION: string = this.REACT_APP_URL_LAWYER_ENDPOINT + "/search-subscription";
    static REACT_APP_URL_LAWYER_AVAILABLE_INVOICE_ACCT_REFS: string =
        this.REACT_APP_URL_LAWYER_ENDPOINT + "/available-invoice-acct-refs";
    // static REACT_APP_URL_LAWYER_AVAILABLE_SUBSCRIPTION_REFS: string = this.REACT_APP_URL_LAWYER_ENDPOINT + "/available-subscription-refs";
    static REACT_APP_URL_LAWYER_CREATE: string = this.REACT_APP_URL_LAWYER_ENDPOINT + "/create";
    static REACT_APP_URL_LAWYER_CLOSE = (id: number) => this.REACT_APP_URL_LAWYER_ENDPOINT + `/${id}/close`;
    static REACT_APP_URL_LAWYER_ADD_PAYMENT = (id: number) => this.REACT_APP_URL_LAWYER_ENDPOINT + `/${id}/add-payment`;
    static REACT_APP_URL_LAWYER_DELETE = (id: number) => this.REACT_APP_URL_LAWYER_ENDPOINT + `/delete/${id}`;
    static REACT_APP_URL_LAWYER_UPDATE = (id: number) => this.REACT_APP_URL_LAWYER_ENDPOINT + `/${id}/update`;
    static REACT_APP_URL_LAWYER_BULK_CLOSE: string = this.REACT_APP_URL_LAWYER_ENDPOINT + "/bulk-close";
    static REACT_APP_URL_LAWYER_BULK_DELETE: string = this.REACT_APP_URL_LAWYER_ENDPOINT + "/bulk-delete";
    static REACT_APP_URL_LAWYER_DASHBOARD_STATUS: string = this.REACT_APP_URL_LAWYER_ENDPOINT + "/dashboard/status";
    static REACT_APP_URL_LAWYER_DASHBOARD_END_REASON: string =
        this.REACT_APP_URL_LAWYER_ENDPOINT + "/dashboard/end-reason";
    static REACT_APP_URL_LAWYER_DASHBOARD_CREDIT_NOTES: string =
        this.REACT_APP_URL_LAWYER_ENDPOINT + "/dashboard/credit-notes";
    static REACT_APP_URL_LAWYER_DASHBOARD_BANKRUPTCIES: string =
        this.REACT_APP_URL_LAWYER_ENDPOINT + "/dashboard/bankruptcies";
    static REACT_APP_URL_LAWYER_DASHBOARD_BANKRUPTCIES_BY_STOP_DATE: string =
        this.REACT_APP_URL_LAWYER_ENDPOINT + "/dashboard/bankruptcies-by-stop-date";

    // Govex Send to Lawyer (legacy: just bumps subscription status to PAYMENTS_LAWYER; no LawyerModel record)
    static REACT_APP_URL_GOVEX_SEND_TO_LAWYER_SEARCH: string =
        this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + "/send-to-lawyer/search";
    static REACT_APP_URL_GOVEX_SEND_TO_LAWYER: string = this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + "/send-to-lawyer";
    static REACT_APP_URL_GOVEX_SEND_TO_LAWYER_PDF: string =
        this.REST_API_GOVEXSUBSCRIPTION_ENDPOINT + "/send-to-lawyer/pdf";

    // WhatsApp
    static REST_API_URL_WHATSAPP: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/whatsapp";
    static REST_API_URL_WHATSAPP_UNREAD: string = this.REST_API_URL_WHATSAPP + "/unread";
    static REST_API_URL_WHATSAPP_UNREAD_COUNT: string = this.REST_API_URL_WHATSAPP + "/unread/count";

    // Message
    static REACT_APP_URL_MESSAGE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/message";

    // Queue
    static REST_API_URL_QUEUE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/queue";

    static REST_API_URL_RELATED_BUS_TYPE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/related-bus-types";
    static REST_API_URL_BUSINESS_MAX_SELECTION: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/business-max-selections";

    static REST_API_URL_TODO_CALL_EVENTS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/todo/call-events";
    static REST_API_URL_TODO_CALL_EVENTS_TODAY_COUNT: string = this.REST_API_URL_TODO_CALL_EVENTS + "/today/count";
    static REST_API_URL_TODO_CREATE: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/todo";
    static REST_API_URL_TODO_BY_PARTNER_RFP: string = this.REST_API_URL_TODO_CREATE + "/by-partner-rfp/";
    static REST_API_URL_CRM_DUE_EVENTS: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/crm/due-events";
    static REST_API_URL_CRM_DUE_EVENTS_TODAY_COUNT: string = this.REST_API_URL_CRM_DUE_EVENTS + "/today/count";
    static REST_API_URL_CRM_SALES_DASHBOARD_DUE: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/crm/sales-dashboard-due";

    static REST_API_URL_DASHBOARD_CURRENT_PIPELINE: string = this.REST_API_URL_DASHBOARD + "/current-pipeline";
    static REST_API_URL_DASHBOARD_OPPORTUNITIES_PIPELINE_OVERVIEW: string =
        this.REST_API_URL_DASHBOARD + "/opportunities-pipeline-overview";
    static REST_API_URL_DASHBOARD_OPPORTUNITIES_PIPELINE: string =
        this.REST_API_URL_DASHBOARD + "/opportunities-pipeline";
    static REST_API_URL_DASHBOARD_OPPORTUNITIES_CLOSED_WON: string =
        this.REST_API_URL_DASHBOARD + "/opportunities-closed-won";
    static REST_API_URL_DASHBOARD_OPPORTUNITIES_CLOSED_LOST: string =
        this.REST_API_URL_DASHBOARD + "/opportunities-closed-lost";
    static REST_API_URL_DASHBOARD_SALES_BY_VENDOR: string = this.REST_API_URL_DASHBOARD + "/sales-by-vendor";
    static REST_API_URL_DASHBOARD_BLOCKED_CLIENTS: string = this.REST_API_URL_DASHBOARD + "/blocked-clients";
    static REST_API_URL_DASHBOARD_CLIENTS_BY_VENDOR: string = this.REST_API_URL_DASHBOARD + "/clients-by-vendor";
    static REST_API_URL_DASHBOARD_SALES_BY_CATEGORY: string = this.REST_API_URL_DASHBOARD + "/sales-by-category";
    static REST_API_URL_DASHBOARD_GROSS_MARGIN_PER_CATEGORY: string =
        this.REST_API_URL_DASHBOARD + "/gross-margin-per-category";

    static REST_API_URL_PAYMENTS_DASHBOARD: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/payments-dashboard";
    static REST_API_URL_PAYMENTS_SALES_BY_PAYMENTS: string =
        this.REST_API_URL_PAYMENTS_DASHBOARD + "/sales-by-payments";
    static REST_API_URL_PAYMENTS_SALES_BY_PAYMENTS_MONTHLY: string =
        this.REST_API_URL_PAYMENTS_SALES_BY_PAYMENTS + "/monthly";
    static REST_API_URL_PAYMENTS_SALES_BY_PAYMENTS_QUARTERLY: string =
        this.REST_API_URL_PAYMENTS_SALES_BY_PAYMENTS + "/quarterly";
    static REST_API_URL_PAYMENTS_SALES_BY_PAYMENTS_YEARLY: string =
        this.REST_API_URL_PAYMENTS_SALES_BY_PAYMENTS + "/yearly";
    static REST_API_URL_PAYMENTS_PAYMENT_DAYS: string = this.REST_API_URL_PAYMENTS_DASHBOARD + "/payment-days";

    static REST_API_URL_SUPPLIER_MARKETING: string = this.APP_API_URL_BACKEND() + "/v1/rest-api/supplier-marketing";
    static REST_API_URL_SPM_MONTH_BY_STATUS: string = this.REST_API_URL_SUPPLIER_MARKETING + "/month-by-status";
    static REST_API_URL_SPM_OVERVIEW_BY_STATUS: string = this.REST_API_URL_SUPPLIER_MARKETING + "/overview-by-status";
    static REST_API_URL_SPM_ASSIGNATIONS: string = this.REST_API_URL_SUPPLIER_MARKETING + "/assignations";
    static REST_API_URL_SPM_ASSIGNATION_DETAILS: string = this.REST_API_URL_SUPPLIER_MARKETING + "/assignation-details";
    static REST_API_URL_SPM_REJECTED_DETAILS: string = this.REST_API_URL_SUPPLIER_MARKETING + "/rejected-details";
    static REST_API_URL_SPM_MONTH_BY_STATUS_PER_VENDOR: string =
        this.REST_API_URL_SUPPLIER_MARKETING + "/month-by-status-per-vendor";
    static REST_API_URL_SPM_AFF_MONTH_BY_STATUS: string = this.REST_API_URL_SUPPLIER_MARKETING + "/aff/month-by-status";
    static REST_API_URL_SPM_AFF_OVERVIEW_BY_STATUS: string =
        this.REST_API_URL_SUPPLIER_MARKETING + "/aff/overview-by-status";
    static REST_API_URL_SPM_AFF_ASSIGNATIONS: string = this.REST_API_URL_SUPPLIER_MARKETING + "/aff/assignations";
    static REST_API_URL_SPM_AFF_ASSIGNATION_DETAILS: string =
        this.REST_API_URL_SUPPLIER_MARKETING + "/aff/assignation-details";
    static REST_API_URL_SPM_AFF_REJECTED_DETAILS: string =
        this.REST_API_URL_SUPPLIER_MARKETING + "/aff/rejected-details";

    // Revenues Per Premium Partner
    static REACT_APP_URL_REVENUES_PER_PREMIUM_PARTNER_SEARCH: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/revenues-per-premium-partner/search";
    static REACT_APP_URL_REVENUES_PER_PREMIUM_PARTNER_TOP: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/revenues-per-premium-partner/top";
    static REACT_APP_URL_REVENUES_PER_PREMIUM_PARTNER_PERIODS: string =
        this.APP_API_URL_BACKEND() + "/v1/rest-api/revenues-per-premium-partner/periods";
}
